<template>
  <v-row justify="center" class="pa-0 ma-0">
    <v-col
      cols="12"
      id="small-header-top-bar"
      tile
      flat
      class="ma-0 px-0 pb-0"
      :class="[headerClasses]"
    >
      <v-row no-gutters justify="center" class="primary">
        <v-row
          class="small-header-top-bar-row pa-0 primary ma-0 mt-2 mb-3 vetalfa-max-width"
          align="center"
          justify="center"
          v-if="!isAppHeader && (_isMobile() || isNavigationDialog)"
        >
          <v-col @click="back()" align-self="center" class="ma-0 pa-0" cols="2">
            <v-row
              v-if="(!isDrugsManagement || backMethod) && !closable"
              class="small-header-top-bar-back-button"
              align="center"
              justify="center"
            >
              <v-icon color="white" size="30" class="pb-0 ma-0">{{
                icons.mdiChevronLeft
              }}</v-icon>
            </v-row>
          </v-col>
          <v-col cols="8" align="center" class="ma-0 pa-0">
            <v-row v-if="!title" align="center" class="ma-0 pa-0 vetalfa-row">
              <v-img
                height="44px"
                position="center"
                class="ma-0 pa-0 ml-2"
                contain
                :src="images.logoWhite"
                :lazy-src="images.logoWhite"
              ></v-img>
            </v-row>
            <v-row
              v-else
              align="center"
              justify="center"
              class="white--text vetalfa-dialog-title small-header-top-bar-title ma-0 pa-0 vetalfa-row"
            >
              <p class="pa-0 ma-0">{{ title }}</p>
            </v-row>
          </v-col>
          <v-col class="ma-0 pa-0" cols="2">
            <vetalfa-header-options
              v-if="hasHeaderOptions"
            ></vetalfa-header-options>
            <v-row
              @click="close()"
              v-else-if="closable"
              style="width: 100%; height: 100%"
              class="pa-0 ma-0"
              align="start"
              justify="center"
            >
              <v-btn icon color="white">
                <v-icon size="22">{{ icons.mdiClose }}</v-icon>
              </v-btn>
            </v-row>

            <v-row
              v-else-if="hasSlotOption"
              class="pa-0 ma-0 pr-4"
              align="center"
              justify="end"
            >
              <slot></slot>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          class="small-header-top-bar-row vetalfa-max-width primary ma-0 mt-2 mb-3 pa-0"
          align="center"
          justify="center"
          v-else
        >
          <v-col class="ma-0 pa-0" cols="6">
            <v-row align="center" class="ma-0 pa-0 vetalfa-row">
              <v-img
                :height="_isMobile() ? '32px' : '40px'"
                position="left"
                @click="returnToHome()"
                class="ma-0 pa-0 ml-4 vetalfa-pointer"
                contain
                :src="appHeaderLogo"
                :lazy-src="appHeaderLogo"
              ></v-img>
            </v-row>
          </v-col>
          <v-col class="ma-0 pa-0" cols="6">
            <v-row
              align="center"
              justify="end"
              class="ma-0 pa-0 pr-4 vetalfa-row"
            >
              <slot name="headerAppHeaderActions"></slot>
              <v-btn
                elevaion="0"
                small
                color="white"
                @click="setUserSection({ comunication: false })"
                fab
              >
                <v-icon small color="primary">{{ _icon("user") }}</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
    </v-col>
    <v-col cols="12" class="ma-0 pa-0">
      <slot name="headerSearch"></slot>
    </v-col>
    <v-col
      cols="12"
      class="vetalfa-max-width ma-0 pa-0 px-4"
      v-if="!!showBreadCrumbAndTitle && !_isMobile()"
    >
      <vetalfa-breadcrumb></vetalfa-breadcrumb>
      <v-row no-gutters justify="space-between" align="center">
        <span class="vetalfa-card-title transparent py-1 mt-1 ma-0 pa-0">
          {{ title }}
        </span>
        <vetalfa-header-options
          v-if="hasHeaderOptions"
        ></vetalfa-header-options>
        <slot></slot>
      </v-row>
    </v-col>

    <v-col cols="12" class="ma-0 pa-0">
      <slot name="headerContent"></slot>
    </v-col>
    <vetalfa-user-section></vetalfa-user-section>
  </v-row>
</template>

<style>
.small-header-top-bar-back-button {
  position: absolute;
  top: calc(38px + env(safe-area-inset-top));
  left: 16px;
  cursor: pointer;
}
.small-header-top-bar-row {
  width: 100%;
  height: 100%;
  height: 64px !important;
}
.small-header-top-bar-title {
  word-break: normal;
}
</style>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from "vuex";
import UserSection from "@/components/UserSection.vue";
import HeaderOptions from "@/components/HeaderOptions.vue";
import imagesConstants from "@/constants/images.js";
import {
  mdiArrowLeft,
  mdiChevronLeft,
  mdiMagnify,
  mdiClose,
  mdiExportVariant,
  mdiProgressClock,
} from "@mdi/js";
export default {
  name: "Header",
  components: {
    "vetalfa-user-section": UserSection,
    "vetalfa-header-options": HeaderOptions,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    breadcrumb: {
      type: String,
      default: null,
    },
    isAppHeader: {
      type: Boolean,
      default: false,
    },
    showBreadCrumbAndTitle: {
      type: Boolean,
      default: false,
    },
    hasHeaderOptions: {
      type: Boolean,
      default: false,
    },
    hasSlotOption: {
      type: Boolean,
      default: false,
    },
    isDrugsManagement: {
      type: Boolean,
      default: false,
    },
    backMethod: {
      type: Function,
      default: null,
    },
    closable: {
      type: Boolean,
      default: false,
    },
    isNavigationDialog: {
      type: Boolean,
      default: false,
    },
    confirmationObject: {
      default: null,
    },
    fullscreen: {
      default: true,
    },
    background: {
      type: String,
      default: "white",
    },
  },
  computed: {
    ...mapGetters("general", ["from", "breadcrumbs"]),
    ...mapState("general", ["routeCount"]),
    headerClasses() {
      return `${
        this.isNavigationDialog || this._isMobile() ? "primary" : "white"
      } ${this.fullscreen ? "vetalfa-padding-top-notch" : ""}`;
    },
    appHeaderLogo() {
      return this._isMobile() ? this.images.logoMobile : this.images.logoWhite;
    },
  },

  mounted() {},
  watch: {
    breadcrumb: {
      handler: function (val) {
        if (!!val && !this._isMobile() && !this.isNavigationDialog) {
          this.$nextTick(() => {
            this.setLastCrumbItemTitle(val);
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions("general", [
      "routeBack",
      "setLastCrumbItemTitle",
      "pushOrPopRouteOfBreadcrumb",
    ]),
    ...mapActions("preferences", ["openRecentlySeen"]),
    ...mapMutations("general", ["setConfirmModel", "setUserSection"]),
    returnToHome() {
      if (this.$route.name === "home") {
        return;
      }
      const stepsBack = this.breadcrumbs.length - 1;
      this.pushOrPopRouteOfBreadcrumb({ offset: stepsBack }).then(() => {
        if (this.routeCount == 1) {
          return this.routeBack();
        }
        this.$router.go(-stepsBack);
      });
    },
    close() {
      this.backMethod();
    },
    back(backConfirmation) {
      if (this.isDrugsManagement) {
        this.backMethod();
      } else if (!!this.confirmationObject && !backConfirmation) {
        this.setConfirmModel({
          ...this.confirmationObject,
          active: true,
          callback: this.backConfirmation,
        });
      } else {
        this.routeBack();
      }
    },
    backConfirmation() {
      this.back(true);
    },
  },
  data() {
    return {
      images: {
        logoWhite: imagesConstants.LOGO_SMALL_HEADER_WHITE,
        logo: imagesConstants.LOGO_SMALL_HEADER,
        logoMobile: imagesConstants.LOGO_SMALL_HEADER_MOBILE,
        gear: imagesConstants.GEAR,
      },
      icons: {
        mdiArrowLeft,
        mdiChevronLeft,
        mdiClose,
        mdiExportVariant,
        mdiMagnify,
        mdiProgressClock,
      },
    };
  },
  created() {},
};
</script>